import * as React from 'react'
import cc from 'classcat'
import styles from './Icon.css'
import icons from './icons'

export interface IconBaseProps {
  onClick?: () => void
  name: string
  size?: string
  spin?: boolean
  color?: string
}

export const defaultProps = {
  size: '24',
  spin: false,
}

interface IconNames {
  [key: string]: string
}

const IconBase: React.FunctionComponent<IconBaseProps> = ({ name, size, color, onClick, spin }) => {
  const classNames = cc([
    styles.icon,
    {
      [styles.spin]: spin,
    },
  ])

  const viewBoxSize = Number(size) < 24 ? '24' : size
  const iconNames: IconNames = icons
  const iconName = iconNames[name]
  return (
    <svg
      className={classNames}
      onClick={onClick}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
    >
      <path fill={color} d={iconName} />
    </svg>
  )
}

IconBase.defaultProps = defaultProps

export default IconBase
